<div class="table-responsive">
    <table class="table">
        <thead>
            <tr>
                <th><small>Emp. Type</small></th>
                <th><small>Present</small></th>
                <th><small>Absent</small></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td><small>Teaching</small></td>
                <td><small>{{ teachingPresenties.length }}</small></td>
                <td><small>{{ teachingAbsentees.length }}</small></td>
            </tr>
            <tr>
                <td><small>Non-Teaching</small></td>
                <td><small>{{ nonTeachingPresenties.length }}</small></td>
                <td><small>{{ nonTeachingAbsentees.length }}</small></td>
            </tr>
        </tbody>
        <tfoot>
            <tr class="fw-bold">
                <td>Total</td>
                <td>{{ teachingPresenties.length + nonTeachingPresenties.length }}</td>
                <td>{{ teachingAbsentees.length + nonTeachingAbsentees.length }}</td>   
            </tr>
        </tfoot>
    </table>
</div>
